import React, { Component } from "react";
import { isMobile } from "react-device-detect";
import { connect } from "react-redux";

import { destroyHomePin, fetchHome, homeDispatch, HOME_DID_MOUNT, HOME_WILL_UNMOUNT } from "actions/home.action";
import { MAIN_CLASS, wrapClassName } from "actions/page.action";

import Banner from "pages/station/home/section/Banner";
import EmptyHomeSection from "pages/station/home/section/EmptyHomeSection";
import ShopfreecaSection from "pages/station/home/section/ShopfreecaSection";
import BoardSection from "pages/station/home/section/BoardSection";
import LiveSection from "pages/station/home/section/LiveSection";
import CatchStorySection from "pages/station/home/section/CatchStorySection";
import VodSection from "pages/station/home/section/VodSection";
import PlayListSection2 from "pages/station/home/section/PlayListSection2";

class Home extends Component {
    constructor(props) {
        super(props);
        this.ref = React.createRef();
    }
    componentDidMount() {
        if (!isMobile) {
            this.props.homeDispatch(HOME_DID_MOUNT);
        }
        // 클레스 초기화 -
        this.props.wrapClassName([MAIN_CLASS, "renew241121_common", "renew241121"]);
    }
    componentWillUnmount() {
        let routePath = window.location.pathname;

        let cssClass = routePath === `/${global.bj_id}` ? [MAIN_CLASS, "renew241121_common", "renew241121"] : [isMobile && routePath === `/${global.bj_id}/search` ? MAIN_CLASS : '',"renew241121_common"];
        this.props.wrapClassName(cssClass);
        this.props.homeDispatch(HOME_WILL_UNMOUNT);
    }
    componentWillMount() {
        this.props.fetchHome();
    }
    /**
     * 고정핀 해제
     * @param {*} post
     */
    handleDestoryPin = (post, location, created) => {
        this.props.destroyHomePin(post.title_no, post.board_type, location, created);

        return;
    };

    render() {
        const { stationInfo, homeReducer, onTabCange } = this.props;
        const { data = {} } = stationInfo;
        const { station = {}, broad, is_adsence = false } = data;
        const { user_nick } = station;
        const { loading, payload = {} } = homeReducer;
        const { sooptore = [], vods = [], boards = [], user_vods = [], user_clips = [], user_boards = [], user_catchs = [], catchstorys = [], banners = [], playlists = [], catchstory_total = 0 } = payload;
        const lang = document.documentElement.lang;

        if (
            !loading &&
            (
            vods.length === 0 &&
            boards.length === 0 &&
            user_vods.length === 0 &&
            user_boards.length === 0 &&
            user_clips.length === 0 &&
            user_catchs.length === 0 &&
            (catchstorys === null || catchstorys.length === 0) &&
            playlists.length === 0  &&
            (sooptore.length === 0 || (sooptore.broadcast_live.length === 0 && sooptore.curation_product.length === 0)) &&
            banners.length === 0
            )
        ) {
            // 채널 홈 빈 페이지 노출
            return <EmptyHomeSection loading={loading} user_nick ={user_nick} broad={broad} style={this.props.style}/> ;
        } else {
            if (isMobile) {
                return (
                    <section className="home" style={this.props.style}>
                        {!loading && (
                            <React.Fragment>
                                {broad && <LiveSection loading={loading} broad={broad} />}

                                <VodSection
                                    loading={loading}
                                    vods={vods}
                                    onDestroyPin={this.handleDestoryPin}
                                    onTabCange={onTabCange}
                                />

                                <BoardSection
                                    title={"게시글"}
                                    loading={loading}
                                    boards={boards}
                                    onDestroyPin={this.handleDestoryPin}
                                    onTabCange={onTabCange}
                                />

                                <VodSection
                                    title={"유저 클립"}
                                    loading={loading}
                                    vods={user_vods}
                                    is_enable_horizontal={true}
                                    onDestroyPin={this.handleDestoryPin}
                                    onTabCange={onTabCange}
                                />

                                <BoardSection
                                    title={"유저 게시글"}
                                    loading={loading}
                                    boards={user_boards}
                                    onDestroyPin={this.handleDestoryPin}
                                    onTabCange={onTabCange}
                                />

                                <CatchStorySection loading={loading} catchstorys={catchstorys} catchstory_total={catchstory_total} />

                                <PlayListSection2
                                    loading={loading}
                                    playlists={playlists}
                                />

                                {lang === "ko" &&
                                    <ShopfreecaSection
                                        loading={loading}
                                        shopfreeca={sooptore}
                                    />
                                }

                                <Banner banners={banners} is_adsence={is_adsence} />
                            </React.Fragment>
                        )}
                    </section>
                );
            } else {
                return (
                    <section className="home" style={this.props.style}>

                        <VodSection
                            loading={loading}
                            sliderPerView={3}
                            vods={vods}
                            onDestroyPin={this.handleDestoryPin}
                            onTabCange={onTabCange}
                        />

                        <BoardSection title={"게시글"} loading={loading} boards={boards} onDestroyPin={this.handleDestoryPin} onTabCange={onTabCange} />

                        <VodSection
                            title="유저 클립"
                            loading={loading}
                            sliderPerView={'auto'}
                            vods={user_vods}
                            is_enable_horizontal={true}
                            onDestroyPin={this.handleDestoryPin}
                            onTabCange={onTabCange}
                        />

                        <BoardSection title={"유저 게시글"} loading={loading} boards={user_boards} onDestroyPin={this.handleDestoryPin} onTabCange={onTabCange} />

                        <CatchStorySection loading={loading} catchstorys={catchstorys} catchstory_total={catchstory_total} />

                        <PlayListSection2
                            loading={loading}
                            playlists={playlists}
                        />

                        {lang === "ko" &&
                            <ShopfreecaSection
                                loading={loading}
                                shopfreeca={sooptore}
                            />
                        }
                        
                        <Banner banners={banners} is_adsence={is_adsence} />
                    </section>
                );
            }
        }
    }
}

const mapStateToProps = (state) => {
    return {
        homeReducer: state.homeReducer,
        stationInfo: state.stationReducer.stationInfo,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        wrapClassName: (classname) => {
            dispatch(wrapClassName(classname));
        },
        fetchHome: () => {
            dispatch(fetchHome());
        },
        destroyHomePin: (title_no, board_type, location, created) => {
            dispatch(destroyHomePin(title_no, board_type, location, created));
        },
        homeDispatch: (type) => {
            dispatch(homeDispatch(type));
        },
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Home);
